if ( typeof ProductImageZoom !== 'function' ) {
	class ProductImageZoom extends HTMLElement {

		constructor(){

			super();

			if ( ! document.getElementById('zoom') ) {
				this.zoom = document.createElement('div');
				this.zoom.id = 'zoom';
				this.zoom.innerHTML = `
					<img />
					<span class="zoom__exit">${KROWN.settings.symbols.zoom_out}</span>
					<span class="zoom__loader">${KROWN.settings.symbols.zoom_loader}</span>
					<div class="zoom__controls">
						<button class="zoom__control zoom__control--in" aria-label="Zoom in">
							<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
								<line x1="12" y1="5" x2="12" y2="19"></line>
								<line x1="5" y1="12" x2="19" y2="12"></line>
							</svg>
						</button>
						<button class="zoom__control zoom__control--out" aria-label="Zoom out">
							<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
								<line x1="5" y1="12" x2="19" y2="12"></line>
							</svg>
						</button>
					</div>
					<div class="zoom__overlay"></div>
				`;
				document.body.append(this.zoom);
				this.zoom.querySelector('.zoom__exit').addEventListener('click', this._productZoomUnmount.bind(this));
			} else {
				this.zoom = document.getElementById('zoom');
			}

			this.onMouseMoveHandlerBinded = this.onMouseMoveHandler.bind(this);
			this.onResizeHandlerBinded = this.onResizeHandler.bind(this);
			this.onTouchStartHandlerBinded = this.onTouchStartHandler.bind(this);
			this.onTouchMoveHandlerBinded = this.onTouchMoveHandler.bind(this);
			this.onTouchEndHandlerBinded = this.onTouchEndHandler.bind(this);
			this.onWheelHandlerBinded = this.onWheelHandler.bind(this);

			// Zoom state
			this.zoomLevel = 1.0;
			this.minZoom = 0.3;
			this.maxZoom = 3.0;
			this.zoomStep = 0.2;
			this.initialSize = { width: 0, height: 0 };
			this.isPinching = false;
			this.lastTouchDistance = 0;
			this.lastTapTime = 0;
			this.lastTapPosition = { x: 0, y: 0 };

			this.addEventListener('click', (e)=>{
				this.zoom.classList.add('opened');
				this.image = this.zoom.querySelector('img');
				this.image.src = this.getAttribute('data-image');
				if ( this.image.naturalWidth > 0 ) {
					this._productZoomMount();
				} else {
					this.image.addEventListener('load', this._productZoomMount.bind(this));
				}
			});

		}

		onMouseMoveHandler(e){
			// Only move image when zoomed in (level > 1.0)
			if (this.zoomLevel <= 1.0) return;
			
			window.clientX = e.clientX;
			window.clientY = e.clientY;
			const x = e.clientX * ( window.innerWidth - this.image.offsetWidth ) / window.innerWidth;
			const y = e.clientY * ( window.innerHeight - this.image.offsetHeight ) / window.innerHeight;
			this.image.style.left = x + 'px';
			this.image.style.top = y + 'px';
		}

		onResizeHandler(){
			// Recalculate initial size and apply current zoom level
			const rf = window.innerWidth > 768 ? 0.5 : 0.8;
			let baseWidth, baseHeight;

			if ( this.image.classList.contains('portrait') ) {
				baseWidth = window.innerWidth * rf;
				baseHeight = baseWidth / this.image.dataset.ratio;
			} else {
				baseHeight = window.innerHeight * rf;
				baseWidth = baseHeight * this.image.dataset.ratio;

				if ( baseWidth < window.innerWidth ) {
					baseWidth = window.innerWidth * rf;
					baseHeight = baseWidth / this.image.dataset.ratio;
				}
			}

			this.initialSize.width = baseWidth;
			this.initialSize.height = baseHeight;

			// Apply zoom level
			this._applyZoom(this.zoomLevel);

			const x = window.clientX * ( window.innerWidth - this.image.offsetWidth ) / window.innerWidth;
			const y = window.clientY * ( window.innerHeight - this.image.offsetHeight ) / window.innerHeight;
		}

		_applyZoom(level, centerX = null, centerY = null) {
			if ( !this.image || !this.initialSize.width ) return;

			// Clamp zoom level
			const oldZoom = this.zoomLevel;
			level = Math.max(this.minZoom, Math.min(this.maxZoom, level));
			this.zoomLevel = level;

			// Calculate new dimensions
			const newWidth = this.initialSize.width * level;
			const newHeight = this.initialSize.height * level;

			// If centering on a specific point (for pinch zoom), maintain that point
			if (centerX !== null && centerY !== null && oldZoom > 0) {
				const zoomRatio = level / oldZoom;
				const currentLeft = parseFloat(this.image.style.left) || 0;
				const currentTop = parseFloat(this.image.style.top) || 0;
				
				// Calculate new position to keep the pinch point fixed
				const newLeft = centerX - (centerX - currentLeft) * zoomRatio;
				const newTop = centerY - (centerY - currentTop) * zoomRatio;
				
				this.image.style.left = newLeft + 'px';
				this.image.style.top = newTop + 'px';
			} else if (level <= 1.0) {
				// When zoomed out, center the image
				this.image.style.left = '0px';
				this.image.style.top = '0px';
			}

			// Apply zoom to image size
			this.image.style.width = newWidth + 'px';
			this.image.style.height = newHeight + 'px';

			// On mobile, adjust scroll position to keep image centered
			if ( (document.body.classList.contains('touch') || document.body.classList.contains('touchevents')) && this.zoom.classList.contains('loaded') ) {
				setTimeout(() => {
					this.zoom.scrollTop = (window.innerHeight - this.image.offsetHeight) / -2;
					this.zoom.scrollLeft = (window.innerWidth - this.image.offsetWidth) / -2;
				}, 10);
			}

			// Update zoom controls state
			const zoomInBtn = this.zoom.querySelector('.zoom__control--in');
			const zoomOutBtn = this.zoom.querySelector('.zoom__control--out');
			if (zoomInBtn) zoomInBtn.disabled = level >= this.maxZoom;
			if (zoomOutBtn) zoomOutBtn.disabled = level <= this.minZoom;
		}

		_zoomIn() {
			this._applyZoom(this.zoomLevel + this.zoomStep);
		}

		_zoomOut() {
			this._applyZoom(this.zoomLevel - this.zoomStep);
		}

		_getTouchDistance(touches) {
			const dx = touches[0].clientX - touches[1].clientX;
			const dy = touches[0].clientY - touches[1].clientY;
			return Math.sqrt(dx * dx + dy * dy);
		}

		onTouchStartHandler(e) {
			if (e.touches.length === 1) {
				// Single touch - check for double tap
				const now = Date.now();
				const touch = e.touches[0];
				const timeSinceLastTap = now - this.lastTapTime;
				const distanceFromLastTap = Math.sqrt(
					Math.pow(touch.clientX - this.lastTapPosition.x, 2) +
					Math.pow(touch.clientY - this.lastTapPosition.y, 2)
				);

				if (timeSinceLastTap < 300 && distanceFromLastTap < 50) {
					// Double tap detected
					e.preventDefault();
					if (this.zoomLevel > 1.0) {
						this._applyZoom(1.0);
					} else {
						this._applyZoom(2.0);
					}
					this.lastTapTime = 0;
				} else {
					this.lastTapTime = now;
					this.lastTapPosition = { x: touch.clientX, y: touch.clientY };
				}
			} else if (e.touches.length === 2) {
				// Pinch gesture start
				e.preventDefault();
				this.isPinching = true;
				this.lastTouchDistance = this._getTouchDistance(e.touches);
			}
		}

		onTouchMoveHandler(e) {
			if (this.isPinching && e.touches.length === 2) {
				e.preventDefault();
				const currentDistance = this._getTouchDistance(e.touches);
				const scale = currentDistance / this.lastTouchDistance;
				const newZoom = this.zoomLevel * scale;
				
				// Calculate center point of pinch gesture
				const centerX = (e.touches[0].clientX + e.touches[1].clientX) / 2;
				const centerY = (e.touches[0].clientY + e.touches[1].clientY) / 2;
				
				// Get current image position relative to viewport
				const imageRect = this.image.getBoundingClientRect();
				const relativeX = centerX - imageRect.left;
				const relativeY = centerY - imageRect.top;
				
				this._applyZoom(newZoom, relativeX, relativeY);
				this.lastTouchDistance = currentDistance;
			}
		}

		onTouchEndHandler(e) {
			if (e.touches.length < 2) {
				this.isPinching = false;
			}
		}

		onWheelHandler(e) {
			if (!this.zoom.classList.contains('opened')) return;
			
			e.preventDefault();
			const delta = e.deltaY > 0 ? -this.zoomStep : this.zoomStep;
			this._applyZoom(this.zoomLevel + delta);
		}

		_productZoomMount(image) {

			this.image.style.left = 0;
			this.image.style.top = 0;
			this.zoomLevel = 1.0; // Reset zoom level

			window.addEventListener('mousemove', this.onMouseMoveHandlerBinded, {passive:true});
			window.addEventListener('wheel', this.onWheelHandlerBinded, {passive:false});

			// Touch events for pinch-to-zoom
			this.zoom.addEventListener('touchstart', this.onTouchStartHandlerBinded, {passive:false});
			this.zoom.addEventListener('touchmove', this.onTouchMoveHandlerBinded, {passive:false});
			this.zoom.addEventListener('touchend', this.onTouchEndHandlerBinded, {passive:true});

			// Zoom control buttons
			const zoomInBtn = this.zoom.querySelector('.zoom__control--in');
			const zoomOutBtn = this.zoom.querySelector('.zoom__control--out');
			if (zoomInBtn) {
				zoomInBtn.addEventListener('click', (e) => {
					e.stopPropagation();
					this._zoomIn();
				});
			}
			if (zoomOutBtn) {
				zoomOutBtn.addEventListener('click', (e) => {
					e.stopPropagation();
					this._zoomOut();
				});
			}

			this.image.dataset.ratio = this.image.naturalWidth / this.image.naturalHeight;
			window.addEventListener('resize', this.onResizeHandlerBinded, {passive:true});
			this.onResizeHandler();

			setTimeout(()=>{
				if ( document.body.classList.contains('touch') || document.body.classList.contains('touchevents') ) {
					this.zoom.scrollTop = ( window.innerHeight - this.image.offsetHeight ) / -2;
					this.zoom.scrollLeft = ( window.innerWidth - this.image.offsetWidth ) / -2;
				}
				this.zoom.classList.add('loaded');
			}, 50);

		}

		_productZoomUnmount() {

			this.zoom.classList.remove('opened');

			setTimeout(()=>{
				window.removeEventListener('resize', this.onResizeHandlerBinded);
				window.removeEventListener('mousemove', this.onMouseMoveHandlerBinded);
				window.removeEventListener('wheel', this.onWheelHandlerBinded);
				this.zoom.removeEventListener('touchstart', this.onTouchStartHandlerBinded);
				this.zoom.removeEventListener('touchmove', this.onTouchMoveHandlerBinded);
				this.zoom.removeEventListener('touchend', this.onTouchEndHandlerBinded);
				
				const image = document.querySelector('#zoom img');
				image.src = '';
				image.className = '';
				image.style = '';
				this.zoom.classList.remove('loaded');
				
				// Reset zoom state
				this.zoomLevel = 1.0;
				this.isPinching = false;
				this.lastTouchDistance = 0;
			}, 300);

		}

	}

  if ( typeof customElements.get('product-image-zoom') == 'undefined' ) {
		customElements.define('product-image-zoom', ProductImageZoom);
	}

}